 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML01_COVER from '@/components/xhtml/01_Cover'
 import XHTML02_TITLEPAGE from '@/components/xhtml/02_Titlepage'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_INTRODUCTIONA from '@/components/xhtml/05_Introductiona'
 import XHTML06_INTRODUCTION from '@/components/xhtml/06_Introduction'
 import XHTML07_DAILY_BREADSA from '@/components/xhtml/07_Daily_Breadsa'
 import XHTML08_DAILY_BREADS from '@/components/xhtml/08_Daily_Breads'
 import XHTML09_TRADITIONAL_BREADSA from '@/components/xhtml/09_Traditional_Breadsa'
 import XHTML10_TRADITIONAL_BREADS from '@/components/xhtml/10_Traditional_Breads'
 import XHTML11_PIZZAA from '@/components/xhtml/11_Pizzaa'
 import XHTML12_PIZZA from '@/components/xhtml/12_Pizza'
 import XHTML13_SWEET_LOAVES_AND_OTHERSA from '@/components/xhtml/13_Sweet_Loaves_and_othersa'
 import XHTML14_SWEET_LOAVES_AND_OTHERS from '@/components/xhtml/14_Sweet_Loaves_and_others'
 import XHTML15_SPECIAL_BREADS_AND_BREADSTICKSA from '@/components/xhtml/15_Special_Breads_and_Breadsticksa'
 import XHTML16_SPECIAL_BREADS_AND_BREADSTICKS from '@/components/xhtml/16_Special_Breads_and_Breadsticks'
 import XHTML17_LEFTOVERSA from '@/components/xhtml/17_Leftoversa'
 import XHTML18_LEFTOVERS from '@/components/xhtml/18_Leftovers'
 import XHTML19_BREAD_FOR_CHILDRENA from '@/components/xhtml/19_Bread_for_Childrena'
 import XHTML20_BREAD_FOR_CHILDREN from '@/components/xhtml/20_Bread_for_Children'
 import XHTML21_ACKNOWLEDGEMENTS from '@/components/xhtml/21_Acknowledgements'
 import XHTML22_INDEX from '@/components/xhtml/22_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/01_Cover",
 			"name" : "xhtml/01_Cover",
 			"component" : XHTML01_COVER
 		},
 		{
 			"path" : "/xhtml/02_Titlepage",
 			"name" : "xhtml/02_Titlepage",
 			"component" : XHTML02_TITLEPAGE
 		},
 		{
 			"path" : "/xhtml/03_Copyright",
 			"name" : "xhtml/03_Copyright",
 			"component" : XHTML03_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Introductiona",
 			"name" : "xhtml/05_Introductiona",
 			"component" : XHTML05_INTRODUCTIONA
 		},
 		{
 			"path" : "/xhtml/06_Introduction",
 			"name" : "xhtml/06_Introduction",
 			"component" : XHTML06_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js